module.exports = __webpack_public_path__ + "img/popup-normal.be2a059d.svg";